import React, { useState } from 'react';

import { ValidationResult } from '@ndvr/portfolio-api';

import { DeleteConfirmModal } from 'widgets/delete/DeleteConfirmModal';
import { ValidationResultModal } from 'widgets/delete/ValidationResultModal';

type DeleteValidationModalProps = {
    recordName: string;
    disabled?: boolean;
    onDelete: () => Promise<ValidationResult | undefined>;
    onClose: (result?: ValidationResult) => void;
};
export const DeleteValidationModal = ({
    recordName,
    disabled = false,
    onDelete,
    onClose,
}: DeleteValidationModalProps) => {
    const [deleteResult, setDeleteResult] = useState<ValidationResult>();

    return deleteResult ? (
        <ValidationResultModal
            result={deleteResult}
            validResultMessage={`${recordName} was successfully deleted`}
            invalidResultMessage={`${recordName} cannot be deleted`}
            onClose={() => {
                setDeleteResult(undefined);
                onClose(deleteResult);
            }}
        />
    ) : (
        <DeleteConfirmModal
            recordName={recordName}
            disabled={disabled}
            onDelete={async () => {
                const result = await onDelete();
                setDeleteResult(result);
            }}
            onClose={onClose}
        />
    );
};
